import React, { useEffect, useState } from "react";
import USAMap from "react-usa-map";
const regionColors = {
    West: "#404040",
    Midwest: "#494949",
    Southwest: "#525559",
    Southeast: "#42454A",
    Northeast: "#535353",
};
const gray = "#525559";
const red = "#e52640";
const allStates = { states: [
    "CA", "OR", "WA", "NV", "ID", "MT", "WY", "AK", "HI", "ND", "SD", "NE",
    "KS", "MN", "IA", "MO", "WI", "IL", "IN", "MI", "OH", "AZ", "NM", "TX",
    "OK", "CO", "UT", "AR", "LA", "MS", "AL", "GA", "FL", "SC", "NC", "TN",
    "KY", "WV", "VA", "ME", "NH", "VT", "MA", "RI", "CT", "NY", "NJ", "PA",
    "DE", "MD", "DC"
], price: 60300 };
const regionMap = {
    West: { states: ["CA", "OR", "WA", "NV", "ID", "MT", "WY", "AK", "HI"], price: 66300 },
    Midwest: { states: ["ND", "SD", "NE", "KS", "MN", "IA", "MO", "WI", "IL", "IN", "MI", "OH"], price: 51500 },
    Southwest: { states: ["AZ", "NM", "TX", "OK", "CO", "UT"], price: 53350 },
    Southeast: { states: ["AR", "LA", "MS", "AL", "GA", "FL", "SC", "NC", "TN", "KY", "WV", "VA"], price: 57200 },
    Northeast: { states: ["ME", "NH", "VT", "MA", "RI", "CT", "NY", "NJ", "PA", "DE", "MD", "DC"], price: 66900 },
};
const defaultRegion = Object.keys(regionMap)[0];
export default function RefineMatcheMap({ setSelectedRegion, selectedRegion }) {
    function makeStatsConfig() {
        const config = {};
        if (selectedRegion === "National") {
            allStates.states.forEach(state => {
                config[state] = { fill: red };
            });
        } else {
            Object.keys(regionMap).forEach(region => {
                regionMap[region].states.forEach(state => {
                    config[state] = { fill: region === selectedRegion ? red : regionColors[region] };
                });
            });
        }
        config["DC2"] = {
            fill: selectedRegion === "Northeast" ? red : regionColors["Northeast"]
        };
        return config;
    }
    const statesCustomConfig = makeStatsConfig();
    const calculateNationalPrice = () => {
        const nationalPrice = allStates.states.reduce((total, state) => {
            const region = Object.keys(regionMap).find(region =>
                regionMap[region].states.includes(state)
            );
            if (region) {
                total += regionMap[region].price;
            }
            return total;
        }, 0);
        return nationalPrice / allStates.states.length;
    };

    const nationalPrice = calculateNationalPrice();

    const mapHandler = (event) => {
        const clickedState = event.target.dataset.name;
        const newRegion = Object.keys(regionMap).find(region =>
            regionMap[region].states.includes(clickedState)
        );
        if (newRegion) {
            setSelectedRegion(newRegion); 
        }
    };
    useEffect(() => {
        if (!selectedRegion) {
            setSelectedRegion(defaultRegion);
        }
    }, [selectedRegion, setSelectedRegion]);
    return (
        <>
            <div className='row mb-5 pb-0'>
                <div className='col-md-7'>
                    <div className='md-title fw-500 mb-4 text-center text-md-start'>Refine Matches by Region</div>
                    <USAMap customize={statesCustomConfig} onClick={mapHandler} />
                </div>
                <div className='col-md-5 ps-md-5 ps-1'>
                    <div className='sm-title fw-500 mb-3 font-16'>Matching Dealers <span className='text-lred'>(32)</span></div>
                    <div className='md-title fw-bold'>
                        ${selectedRegion === "National" ? allStates.price.toLocaleString() : regionMap[selectedRegion]?.price?.toLocaleString() || "N/A"}
                        <span className='font-13 fw-400 vertical-align-5 ps-2 d-inline-block'>Avg. List Price</span>
                    </div>
                    <div className='md-block'>
                        <div className='row g-3'>
                            {[
                                "West",
                                "National", 
                                ...Object.keys(regionMap).filter(region => region !== "West"),
                            ].map(region => (
                                <div className='col-md-6 col-6' key={region}>
                                    <button
                                        type="button"
                                        className={`md-tab-box d-block w-100 text-start ${selectedRegion === region ? "active" : ""}`}
                                        onClick={() => setSelectedRegion(region)}
                                    >
                                        <div className='xs-title font-15 fw-400 mb-2'>
                                            {region} {region == "National" ? 
                                                <span className='text-lred'>({allStates.states.length})</span> :
                                                <span className='text-lred'>({regionMap[region].states.length})</span>
                                            }
                                        </div>
                                        <div className='xs-title fw-500 font-15'>
                                            ${region === "National" ? allStates.price.toLocaleString() : regionMap[region]?.price?.toLocaleString() || "N/A"}
                                        </div>
                                    </button>
                                </div>
                            ))}
                        </div>
                    </div>

                </div>
            </div>
        </>
    );
}
